import { useState } from "react";
import { getSidebarTheme } from "../../config/sidebarThemes";
import { initialsOf } from "./accountDisplay";

const SIZES = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  xl: "h-20 w-20 text-2xl",
} as const;

/**
 * The person's photo, or their initials on their sidebar's colours, so the
 * avatar in the top bar belongs to the same workspace as the sidebar.
 */
export function UserAvatar({
  name,
  role,
  photo,
  size = "md",
}: {
  name: string;
  role?: string;
  photo?: string | null;
  size?: keyof typeof SIZES;
}) {
  const [broken, setBroken] = useState(false);
  const theme = getSidebarTheme(role);
  if (photo && !broken) {
    return <img src={photo} alt="" onError={() => setBroken(true)} className={`${SIZES[size]} shrink-0 rounded-full object-cover ring-2 ring-white`} />;
  }
  return (
    <span
      aria-hidden
      className={`${SIZES[size]} flex shrink-0 items-center justify-center rounded-full font-bold tracking-wide ring-2 ring-white`}
      // White, not the sidebar's gold: gold on the academic navy falls below 4.5:1.
      style={{ background: `linear-gradient(135deg, ${theme.light}, ${theme.deep})`, color: "#fff" }}
    >
      {initialsOf(name)}
    </span>
  );
}
